import React, { useState } from "react";

import Grid from "@material-ui/core/Grid";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import { useHistory } from "react-router-dom";

import { notify } from "../../utils/notify";
import ModalLoading from "../../components/modalLoading/ModalLoading";
import Header from "../../components/header/Header";
import { userFirstAccess } from "../../repositories/userRepository";
import TextFieldCustom from "../../components/basic/TextFieldCustom";

const FormSendCode = ({ location }) => {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const { push, goBack } = useHistory();

  const handleSubmit = async () => {
    try {
      if (!code) {
        setErrors({ code: true });
        return notify("Preencha o código de verificação.");
      }

      setLoading(true);

      const { data: result } = await userFirstAccess({
        code,
        email: location.state,
      });

      if (!result || !result.success) {
        setLoading(false);
        notify(
          "Não foi possível confirmar o usuário, certifique-se de que o código informardo está correto."
        );
        return;
      }

      setLoading(false);
      return push("/login", location.state);
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <ModalLoading loading={loading} />}
      <Header />
      <Grid
        container
        alignItems="center"
        justify="center"
        className="wrapper fadeInDown"
        style={{ marginTop: 90 }}
      >
        <Grid
          container
          spacing={2}
          alignItems="center"
          justify="center"
          item
          lg={5}
          md={7}
          sm={8}
          xs={10}
          id="formContent"
        >
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <ArrowBackIcon className="iconGoBack" onClick={goBack} />
            <label className="title">Primeiro Acesso</label>
          </Grid>

          <label className="subTitle">
            O código de verificação foi enviado em seu e-mail.
          </label>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextFieldCustom
              label="Código de verificação*"
              autoFocus
              type="number"
              value={code}
              setValue={setCode}
              error={errors.code}
            />
          </Grid>

          <button
            id="buttonStyle"
            className="btn btn-info btn-block"
            onClick={handleSubmit}
          >
            Verificar
          </button>
        </Grid>
      </Grid>
    </>
  );
};

export default FormSendCode;
